import { CommonModule } from '@angular/common';
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { NgModule } from '@angular/core';
import { ANALYTICS_CHARTS_GATEWAY } from '@prlw/core/analytics-charts/analytics-charts-gateway.token';
import { HttpAnalyticsChartsGateway } from './analytics-charts.gateway';

@NgModule({
  imports: [CommonModule],
  providers: [
    { provide: ANALYTICS_CHARTS_GATEWAY, useClass: HttpAnalyticsChartsGateway },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AnalyticsChartsDataModule {}
